module.exports = __webpack_public_path__ + "static/media/gray-logo.5799841c.png";